import { applySpec, propOr } from 'ramda';

const ActionDetail = applySpec({
  position: propOr('', 'position'),
  textOfButtonOrLink: propOr('', 'textOfButtonOrLink'),
  pageOrScreen: propOr('', 'pageOrScreen'),
  referrer: propOr('', 'referrer'),
});

export default ActionDetail;
